import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from 'languages/i18n';

import Main from 'pages/Main';
import Info from 'pages/Info';
import Search from 'pages/Search';

import { unregister } from './registerServiceWorker';

ReactDOM.render(
  <I18nextProvider i18n={i18n} >
    <Router basename='/catalogocartoteca'>
      <Switch>
        <Redirect exact={true} from='/' to={'/home'} />
        <Route path='/home' extact={true} component={Main} />
        <Route path='/search/:option' extact={true} component={Search} />
        <Route path='/info/:name' extact={true} component={Info} />
        <Route path='*' exact={true} component={Main} />
      </Switch>
    </Router>
  </I18nextProvider>,
  document.getElementById('root')
);

unregister();
